import { Minus, Plus } from "lucide-react";
import { toast } from "sonner";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "../components/ui/sheet";
import { useCart } from "./cart";
import { useLang } from "./i18n";

const FREE = 150;

export const CartDrawer = () => {
  const { items, setQty, total, open, setOpen, count } = useCart();
  const { t } = useLang();
  const left = Math.max(0, FREE - total);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-drawer" data-lenis-prevent className="bg-[#050505] text-white border-l border-white/15 w-full sm:max-w-md p-0 flex flex-col">
        <div className="p-6 border-b border-white/15">
          <SheetTitle className="f-disp uppercase text-4xl text-white">{t("cart.title")} [{count}]</SheetTitle>
          <SheetDescription className="f-mono text-xs text-zinc-400 mt-2">
            {left > 0 ? t("cart.left", { n: left }) : t("cart.free")}
          </SheetDescription>
          <div className="mt-3 h-1 bg-white/10"><div className="h-full bg-[#FF2A2A] transition-[width] duration-500" style={{ width: `${Math.min(100, (total / FREE) * 100)}%` }} /></div>
        </div>
        <div className="flex-1 overflow-y-auto p-6 space-y-5">
          {items.length === 0 && <p data-testid="cart-empty" className="text-zinc-400 text-sm">{t("cart.empty")}</p>}
          {items.map((i) => (
            <div key={i.key} data-testid={`cart-item-${i.key}`} className="flex gap-4">
              <div className="w-20 h-24 bg-[#121212] shrink-0"><img src={i.img} alt={i.name} className="w-full h-full object-contain" /></div>
              <div className="flex-1 min-w-0">
                <div className="f-disp uppercase text-xl leading-none">{i.name}</div>
                <div className="f-mono text-xs text-zinc-400 mt-1">{t("cart.size")} {i.size}{i.color ? ` — ${t("c." + i.color)}` : ""}{i.pre ? ` — ${t("cart.pre")}` : ""}</div>
                <div className="mt-3 flex items-center justify-between">
                  <div className="flex items-center border border-white/20">
                    <button data-testid={`cart-dec-${i.key}`} onClick={() => setQty(i.key, i.qty - 1)} className="w-8 h-8 flex items-center justify-center hover:bg-white/10"><Minus className="w-3 h-3" /></button>
                    <span className="w-8 text-center f-mono text-sm">{i.qty}</span>
                    <button data-testid={`cart-inc-${i.key}`} onClick={() => setQty(i.key, i.qty + 1)} className="w-8 h-8 flex items-center justify-center hover:bg-white/10"><Plus className="w-3 h-3" /></button>
                  </div>
                  <span className="f-mono text-sm">${i.price * i.qty}.00</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="p-6 border-t border-white/15">
          <div className="flex justify-between f-mono text-sm mb-4"><span>{t("cart.sub")}</span><span data-testid="cart-total">${total}.00</span></div>
          <button
            data-testid="cart-checkout-button"
            disabled={!items.length}
            onClick={() => toast(t("cart.demo"), { description: t("cart.demod") })}
            className="og-btn og-btn--red w-full justify-center disabled:opacity-40"
          >
            {t("cart.checkout")}
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
};
